// style
import './style/style.css'
// hook and controller
import useGetData from '../../hook/getData';
import { GetSettings } from '../../services/client/settings/getSettings';
import { useEffect } from 'react';
const AboutUs = () => {
    const { data: settings } = useGetData(['settings'], GetSettings)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <section className="contactus bg-white py-5">
                <div className="container">
                    <div className="row gy-4 overflow-hidden align-items-center">
                        <div className="col-md-5 text-start" data-aos="fade-up">
                            <img src={require('./../../assets/media/banner/aboutUs.png')} alt="about" className="about-img" />
                        </div>
                        <div className="col-md-7" data-aos="fade-right">
                            <h1 className='fw-bold card-title h4'>درباره ما</h1>
                            {settings?.data ? (settings.data) : (
                                <>
                                    <p className='mt-3 line-30 card-text'>
                                        ارس کام با هدف فراهم کردن دسترسی آسان به محصولات آرایشی، بهداشتی و مراقبت شخصی اصل، فعالیت خود را آغاز کرده است. ما تلاش می‌کنیم با ارائه مجموعه‌ای از بهترین برندهای معتبر داخلی و خارجی، تجربه‌ای متفاوت، مطمئن و لذت‌بخش از خرید آنلاین را برای مشتریان خود رقم بزنیم.
                                        در ارس کام، تمامی محصولات با **تضمین اصالت کالا** و از تأمین‌کنندگان معتبر تهیه و عرضه می‌شوند تا با اطمینان کامل، زیبایی و سلامت خود را به ما بسپارید. مجموعه ما شامل انواع محصولات مراقبت پوست، مراقبت مو، لوازم آرایشی، عطر و ادکلن، محصولات بهداشتی، مراقبت بدن و اکسسوری‌های زیبایی است که با دقت انتخاب شده‌اند تا پاسخگوی نیازهای مختلف مشتریان باشند.
                                    </p>
                                    <ul className='list-group px-0'>
                                        <li className='list-group-item px-0'>
                                            ✔ تضمین اصالت کالا – تمامی محصولات اصل، دارای کیفیت تضمین‌شده و از برندهای معتبر هستند.
                                        </li>
                                        <li className='list-group-item px-0'>
                                            ✔ تنوع گسترده محصولات – مجموعه‌ای کامل از محصولات آرایشی، بهداشتی و مراقبت شخصی برای تمامی سلیقه‌ها و نیازها.
                                        </li>
                                        <li className='list-group-item px-0'>
                                            ✔ قیمت مناسب و رقابتی** – ارائه بهترین محصولات با قیمت منصفانه و پیشنهادهای ویژه.
                                        </li>
                                    </ul>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutUs;